import { endPoints } from "@/constants/apiSetting";
import httpClient from "./HttpClient";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import router from "@/router";
import SweetAlertService from "@/service/SweetAlertService";
import axios from "axios";
const actionScope = `LoaderStore`;
function addTokenToAxiosConfig(config) {
  config.headers.token = store.getters[StoreGetter.token];
  return config;
}

function isMiddlewareAPI(url) {
  const ignoreTokenAPI = [
    endPoints.authentication.login,
    endPoints.localization,
    endPoints.forgotpassword,
    endPoints.verifyCandidate,
    endPoints.validateToken
  ];
  let isMiddlewareAPI = true;
  for (let i = 0; i < ignoreTokenAPI.length; i++) {
    if (url.includes(ignoreTokenAPI[i])) {
      isMiddlewareAPI = false;
      break;
    }
  }
  return isMiddlewareAPI;
}

export function setupInterceptors({ dispatch }) {
  let requestsPending = 0;
  const req = {
    pending: () => {
      requestsPending++;
      dispatch(`${actionScope}/show`);
    },
    done: () => {
      requestsPending--;
      if (requestsPending <= 0) {
        dispatch(`${actionScope}/hide`);
      }
    }
  };
  httpClient.interceptors.request.use(
    config => {
      req.pending();
      const serverRouter = store.getters[StoreGetter.serverRouter];
      if (serverRouter) {
        config.baseURL = serverRouter.ServerIP;
        // config.baseURL = "http://localhost:59732/api/";
      }

      if (config.url) {
        if (isMiddlewareAPI(config.url)) {
          config = addTokenToAxiosConfig(config);
        }
      }

      return config;
    },
    error => {
      requestsPending--;
      req.done();
      return Promise.reject(error);
    }
  );
  httpClient.interceptors.response.use(
    response => {
      req.done();
      const customConfig = response.config;

      if (customConfig.isShowMsg) {
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
      return Promise.resolve(response);
    },
    error => {
      req.done();
      if (error.message == "Request failed with status code 401") {
        SweetAlertService.error(
          "Error",
          "User not authenticated, please login again"
        );
        const compCode = store.getters[StoreGetter.user].CompCode;
        store.dispatch({
          type: `AuthenticationStore/initUser`,
          payload: {}
        });
        router.push(`/login/${compCode}`);
      } else {
        SweetAlertService.error("Error", error.message);
      }
      return Promise.reject(error);
    }
  );
}



// WEBPACK FOOTER //
// ./src/common/service/HttpInterceptors.js